import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import DragItem from '../../../../dnd/DragItem';

import CheckboxSelect from '../partial/CheckboxSelect';
import ColumnChecker from '../../ColumnChecker';
import ColumnActions from '../../ColumnActions';
import ColumnUpgrade from '../../ColumnUpgrade';
import ColumnCover from '../../ColumnCover';
import ColumnTrack from '../../ColumnTrack';
import ColumnLabel from '../../ColumnLabel';
import ColumnGenre from '../../ColumnGenre';
import ColumnBpmKey from '../../ColumnBpmKey';
import ColumnMore from '../../ColumnMore';
import ColumnDeleteAction from '../../ColumnDeleteAction';
import ColumnDate from '../../ColumnDate';
import ColumnTime from '../../ColumnTime';
import ColumnRemixer from '../../ColumnRemixer';

import useTrackAccess from '../../hooks/useTrackAccess';
import useCart from '../../../../cart/hooks/useCart';

// React.memo(
const ConnectedRowCart = ({
  item, index, width, height, className = 'item',
  onLoadMore, onDelete,
  idParent, onClick,
  end,
  isTablet, touchEditor,
  dnd = true
}) => {

  const { removeToCart } = useCart(item);
  const removeToMainCart = () => {
    removeToCart(() => { onDelete(index); })
  }
  const {
    isEnabled, isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, showContextMenu, ContextMenuContent
  } = useTrackAccess(item, idParent, index, removeToMainCart /*removeToCart*/ , true, false);

  const onClickRow = (e) => onClick(item, e, index);
  const touchClick = (e) => {
    onClick(item, e, index, true);
    e.stopPropagation();
  }

  const RSizeChecker = 0; // 10;
  const RSizeNumber = 30;
  const RSizeActions = isTablet ? 90: 50;
  const RSizeCover = 48;
  const RSizeMore = 35;
  const RSizeExtra = 45;
  const RSizeKey = 90;
  const RSizeRelease = 95;
  const RSizeTime = 50;

  const RTotal = RSizeChecker + RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeExtra + RSizeKey + RSizeRelease + RSizeTime;
  let RSizeTrack = ((width - RTotal) * 33 / 100);
  let RSizeRemixer = ((width - RTotal) * 20 / 100);
  let RSizeLabel = ((width - RTotal) * 25 / 100);
  let RSizeGenre = ((width - RTotal) * 22 / 100);
  RSizeTrack += (Config.LIST_HEADER_HAS_REMIXER) ? 0 : RSizeRemixer;
  RSizeTrack += (Config.LIST_HAS_MORE) ? 0 : RSizeTime;

  return (
    <>
      <DragItem dnd={dnd} type={isEnabled ? `TRACK` : `X`} idParent={idParent} partialGrab={touchEditor} begin={beginDnD} end={end} onClick={onClickRow} ContextMenuContent={ContextMenuContent} item={item} onMouseEnter={onLoadMore ? onLoadMore(index) : null} className={`${isPreview && `preview`} ${(previewPlayer && !previewPlayer.isPlaying) && 'off'} ${className} ${(isDisabled) && `disabled`} `} style={stylePreview({ width, height })}>
        {  touchEditor ? (
          <div style={{ width: RSizeChecker + RSizeNumber, zIndex: 500 }} >
            <CheckboxSelect trackID={item.id} style={{marginLeft: 9}} onClick={touchClick}  />
          </div>
        ) : (
          <ColumnChecker width={RSizeNumber} isDisabled={isDisabled} trackID={item.id} value={index + 1} />
        )}
        <ColumnActions width={RSizeActions} keyID={item.id} isPreview={(!previewPlayer.isPlaying || !isPreview)} isTablet={isTablet}
            onClickPlayDeckA={playerLoadSong(1)} onClickPlayDeckB={playerLoadSong(2)}
            onPreviewBackward={previewPlayer.backward} onPreviewForward={previewPlayer.forward} />
        <ColumnCover width={RSizeCover} item={item} previewPlayer={previewPlayer} />
        <ColumnTrack width={RSizeTrack} item={item} includeRemixers={false} containerStyle={{ marginRight: 10 }}  />
        { (Config.LIST_HEADER_HAS_REMIXER) && (
          <ColumnRemixer width={RSizeRemixer} style={{ zIndex: 50 }} remixers={item.remixers} />
        )}
        <ColumnLabel width={RSizeLabel - 8} item={item} style={{ marginRight: 8 }}  />
        <ColumnGenre width={RSizeGenre} item={item} />
        <ColumnBpmKey width={RSizeKey} item={item} />
        { isEnabled ? (
          <>
            <ColumnDate width={RSizeRelease} date={item.release} />
            <ColumnTime width={RSizeTime} duration={item.length} durationMs={item.length_ms} />
            <ColumnDeleteAction  width={RSizeExtra} onClick={removeToMainCart} />
            <ColumnMore width={RSizeMore} id={item.id} onClick={showContextMenu} hasTouch={false} />
          </>
        ) : (
          <ColumnUpgrade width={RSizeRelease + RSizeTime + RSizeMore} />
        )}
      </DragItem>
    </>
  )

};

ConnectedRowCart.propTypes = {
  item: PropTypes.object.isRequired,
  idParent: PropTypes.any,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  end: PropTypes.func,
  onDelete: PropTypes.func,
  dnd: PropTypes.bool
}

const RowCart= connect(
  state => ({
    isTablet: state.layoutTablet,
    touchEditor: state.touchEditor
  })
)(ConnectedRowCart);

export default RowCart;
